<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Planday - Portal - Employee Groups</h2>

    <vs-table
      v-if="portal"
      ref="table"
      class="mt-8"
      v-model="selected"
      :data="portal.employeeGroups"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="id">Planday Portal ID</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-chip :color="tr.isPosition ? 'success' : ''">
                {{ tr.name }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.id }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      portal: null,
      selected: null
    };
  },
  methods: {
    getPortal: function (portalId) {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/planday/' + portalId)
          .then(resp => {
            this.portal = resp.data

            console.log(this.portal);
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch portal:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  created() {
    this.getPortal(this.$route.params.portalId);
  }
};
</script>